import './styles/styles.css';


export const userInputs = [
  {
    id: "dni",
    label: "DNI",
    type: "text",
    placeholder: "DNI",
  },
  {
    id: "tipVS",
    label: "Tip VS (obligatorio)",
    type: "text",
    placeholder: "Número identificación del vigilante*",
  },
  {
    id: "telefono",
    label: "Telefono",
    type: "text",
    placeholder: "Número de teléfono",
  },
  {
    id: "email",
    label: "email",
    type: "email",
    placeholder: "correo electrónico"
  },
  {
    field: "persona",
    headerName: "Persona",
    width: 150,
    renderCell: (params) => {
      if (!params.value) return null;
      return (
        <div style={{
          borderRadius: '10px',
          background: 'rgba(73, 80, 87, 0.27)',
          padding: '5px 10px',
          color: 'black',
          whiteSpace: 'nowrap'
        }}>
          {params.value}
        </div>
      );
    },
  },
];

// Campos del formulario de creación de tienda/servicio.
// El formulario agrupa los inputs por `section`:
//   - identificacion: numTienda, localizacion, fechaAlta, fechaFin
//   - ubicacion: delegacion (Freematica)
//   - datosServicio: tipo, clase, calendarioFestivos, inspectorCod,
//                    controlModificacion, observacionesPuesto
export const productInputs = [
  // ── Identificación ─────────────────────────────────────────
  {
    id: "numTienda",
    label: "Identificador servicio",
    type: "text",
    placeholder: "tienda",
    maxLength: 40,
    section: "identificacion",
  },
  {
    id: "localizacion",
    label: "Localización",
    type: "text",
    placeholder: "CONTRATO/SERVICIO (ej: 13550/03)",
    section: "identificacion",
  },
  {
    id: "fechaAlta",
    label: "Fecha de Alta",
    type: "date",
    placeholder: "dd/mm/yyyy",
    section: "identificacion",
  },
  {
    id: "fechaFin",
    label: "Fecha de Fin (opcional)",
    type: "date",
    placeholder: "dd/mm/yyyy",
    section: "identificacion",
  },
  // ── Ubicación ──────────────────────────────────────────────
  {
    id: "delegacion",
    label: "Delegación",
    type: "catalogo",
    catalogo: "delegaciones",
    section: "ubicacion",
  },
  // ── Datos del servicio (Freematica) ────────────────────────
  {
    id: "tipo",
    label: "Tipo de servicio",
    type: "catalogo",
    catalogo: "tiposServicio",
    section: "datosServicio",
  },
  {
    id: "clase",
    label: "Clase de servicio",
    type: "catalogo",
    catalogo: "clasesServicio",
    section: "datosServicio",
  },
  {
    id: "calendarioFestivos",
    label: "Calendario de festivos",
    type: "catalogo",
    catalogo: "calendariosFestivos",
    section: "datosServicio",
  },
  {
    id: "inspectorCod",
    label: "Inspector (Freematica)",
    type: "catalogo",
    catalogo: "inspectores",
    section: "datosServicio",
  },
  {
    id: "controlModificacion",
    label: "Control de modificación",
    type: "text",
    placeholder: "0 / 1",
    section: "datosServicio",
  },
  {
    id: "observacionesPuesto",
    label: "Observaciones del puesto",
    type: "textarea",
    placeholder: "Notas operativas (teléfonos, llaves, contactos…)",
    section: "datosServicio",
  },
];

export const clientesInputs = [
  {
    id: "nombre",
    label: "Identificador cliente",
    type: "text",
    placeholder: "nombre",
  },
  {
    id: "telefono",
    label: "Telefono",
    type: "number",
    placeholder: "Número de teléfono",
  },
  {
    id: "email",
    label: "email",
    type: "email",
    placeholder: "correo electrónico"
  },
];
